import { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';

export function Login() {
  const [submissionMessage, setSubmissionMessage] = useState('');

  const onSubmit = (params, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }

    setSubmitting(true);
    setSubmissionMessage(null);

    EcomEngineAPI.account.login(params).then((result) => {
      setSubmitting(false);

      if (result.status === 401) {
        setSubmissionMessage('Invalid login credential');
      }

      if (result.message) {
        setSubmissionMessage(result.message);
      }

      // Success, do the redirection.
      if (result.id) {
        const isAgent = result.client_type_is_agent;
        const { loginRedirect } = window.ecom.craft3config.user;
        const preferredUrl = isAgent ? loginRedirect : null;
        const url = preferredUrl || document.referrer || '/';

        // Have to use assign here - https://github.com/jsdom/jsdom/issues/2112#issuecomment-361195043
        window.location.assign(url);
      }
    });
  };

  const formSchema = Yup.object().shape({
    username: Yup.string().required('Username or Email is required'),
    password: Yup.string().required('Password is required'),
  });

  return (
    <Formik
      initialValues={{
        username: '',
        password: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div className="row">
          <div className="col-12 col-sm-8 col-lg-5 mx-auto">
            <div className="p-5 my-md-5 bg-white border">
              <h2 className="mb-3">Login</h2>

              {submissionMessage && (
                <div className="alert alert-danger alert-dismissible fade show">
                  {submissionMessage}
                  <button
                    type="button"
                    className="close"
                    data-testid="dismiss-message"
                    onClick={() => setSubmissionMessage(null)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}

              <Form className="needs-validation space-y-4">
                <div>
                  <label htmlFor="username">Username or Email</label>
                  <Field
                    name="username"
                    className="form-control"
                    id="username"
                    placeholder="Username or Email"
                  />
                  <ErrorMessage
                    className="text-danger text-small mt-1"
                    name="username"
                    component="div"
                    id="username_error"
                  />
                </div>

                <div>
                  <label htmlFor="password">Password</label>
                  <Field
                    name="password"
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Password"
                  />
                  <ErrorMessage
                    className="text-danger text-small mt-1"
                    name="password"
                    component="div"
                    id="password_error"
                  />
                </div>

                <div>
                  <div className="mb-5">
                    <a className="text-small" href="/reset_password">
                      Forgot your password?
                    </a>
                  </div>
                  <button
                    data-testid="login-submit"
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner-third animation-momentum-spin me-1" />{' '}
                        Validating
                      </>
                    ) : (
                      'Login'
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}
export default Login;
